import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography, useTheme } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';

type Props = {
  open: boolean;
  finalChargeFormatted: string;
  onDone: () => void;
};

export default function CancelSubscriptionSuccessModal({ open, finalChargeFormatted, onDone }: Props) {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={onDone} maxWidth='sm' fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <IconButton
        aria-label='Close'
        onClick={onDone}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
      >
        <IoClose size={22} />
      </IconButton>
      <DialogContent sx={{ textAlign: 'center', pt: 4, pb: 1, p: '24px', maxWidth: '559px' }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: '#DBFCDE',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2
          }}
        >
          <IoMdCheckmark size={44} color='#077F13' />
        </Box>
        <Typography fontSize={20} fontWeight={500} mb={2}>
          Subscription Cancelled
        </Typography>
        <Typography fontSize={14} color='text.secondary' mb={2}>
          A final charge of {finalChargeFormatted} has been processed and all payment methods removed.
        </Typography>
        <Box
          sx={{
            bgcolor: theme.palette.error.light,
            color: theme.palette.error.main,
            borderRadius: '8px',
            p: '12px',
            textAlign: 'left'
          }}
        >
          <Typography fontSize={16} fontWeight={500} mb={1}>
            Account Status: Inactive
          </Typography>
          <Typography fontSize={14}>
            Services for your account have been stopped.Your account data will be retained for 30 days. After that, the
            account will be archived and associated data will be permanently removed.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'flex-end' }}>
        <Button variant='contained' onClick={onDone}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
